import React from 'react';

const Marker = ({ selected, toggleSelected, office }) => {
  return (
    <button
      type="button"
      className={`business-locator__map-marker ${selected === office.id ? 'selected' : ''}`}
      onClick={() => toggleSelected(office)}
      aria-label={office.name}
    >
      <span className="sec-icon sec-icon-solid-marker" />
    </button>
  );
};

export default Marker;
